export const DEFAULT_FRAME_HEIGHT = '500'
export const DEFAULT_VIDEO_HEIGHT = '500px'
